import Layout from "../Layout";
import Hta from "./Hta";
import Fees from "./Fees";
import { Helmet } from "react-helmet";

const Admission = () => {
    return ( 
        <Layout>
            <Helmet> 
                <meta
                    name="description"
                    content="Life Long Polytechnic is Registered with the Ministry of Higher And Tertiary Education, Science and Technology Development."
                />
                <title>Admission Information</title>
            </Helmet>
            <div className="light-bg">
                <Hta />
                <Fees />
            </div>
        </Layout>
     );
}
 
export default Admission;